import { IApiInvestigationRoleNames } from "src/app/shared/modules/graphql/types/types";

export const OC_ON_SCENE_EXAM = "Origin & Cause Investigation with on scene exam";
export const OC_CONTINUED_WITH_JSE = "Origin & Cause Investigation continued with joint scene exam";
export const OC_CONTINUED_WITH_LAB_EXAM = "Origin & Cause Investigation continued with laboratory exam of evidence";
export const OC_EVIDENCE_TRANSPORT_SHIPPING = "Origin & Cause Evidence Transport/Shipping time";
export const DESK_REVIEW_OC = "Desk review of origin & cause investigation";
export const FOLLOW_UP_CASE_WORK = "Follow up case work";
export const ADDITIONAL_ADMIN_WORK = "Additional administrative work (non-billable)";
export const INV_REPORT_WITH_CAPTIONED_PHOTOS = "Investigation report with captioned photographs";
export const CASE_REVIEW_FOR_DEPO_PREP = "Case review for deposition prep";
export const TESTIMONY_TIME = "Testimony time";
export const EXAM_WITH_HAZMAT = "Exam with Hazmat procedures";
export const TECH_REVIEW_NFPA_921 = "Technical Review in accordance with NFPA 921 section 4.6.2 Technical Review";
export const AUTO_EQUIPMENT_EXPERT_ANALYSIS = "Auto & Equipment expert analysis";
export const HVAC_EXPERT_ANALYSIS = "HVAC expert analysis";
export const EE_EXPERT_ANALYSIS = "Electrical Engineer expert analysis (applies to scene or lab exams)";
export const EE_REPORT = "Electrical Engineer report";
export const SENIOR_EE_EXPERT_ANALYSIS = "Senior Electrical Engineer expert analysis (applies to scene or lab exams)";
export const SENIOR_EE_REPORT = "Senior Electrical Engineer report";
export const EVIDENCE_TECH_REMOVAL_RETRIEVAL = "Evidence technician removal and retrieval of evidence";
export const EVIDENCE_TECH_TRANSFERRING = "Evidence technician transferring evidence";
export const EVIDENCE_TECH_LAB_EXAM_ASSIST = "Evidence technician lab exam assist";
export const MASTER_ELECTRICIAN_EXPERT_ANALYSIS = "Master Electrician expert analysis";
export const FIRE_PROTECTION_ENGINEER_EXAM = "Fire Protection Engineer";
export const TRAINING_TIME = "Training time";
export const EE_TECH_REVIEW_NFPA_921 = "Technical Review in accordance with NFPA 921  section 4.6.2 Technical Review";

export const BILLING_OPTION_SHORT_LABELS: Record<string, string> = {
  [OC_ON_SCENE_EXAM]: "O&C on scene exam",
  [OC_CONTINUED_WITH_JSE]: "O&C continued with JSE",
  [OC_CONTINUED_WITH_LAB_EXAM]: "O&C cont. with Lab Exam",
  [EXAM_WITH_HAZMAT]: "Hazmat",
  [MASTER_ELECTRICIAN_EXPERT_ANALYSIS]: "Master Elect Exam",
  [AUTO_EQUIPMENT_EXPERT_ANALYSIS]: "Auto Hvy Equip Exp Exam",
  [HVAC_EXPERT_ANALYSIS]: "HVAC  Expert Exam",
  [EE_EXPERT_ANALYSIS]: "EE Exam",
  [FIRE_PROTECTION_ENGINEER_EXAM]: "FPE Exam",
  [SENIOR_EE_EXPERT_ANALYSIS]: "Senior EE Exam",
  [EVIDENCE_TECH_REMOVAL_RETRIEVAL]: "Evid Tech Transport",
  [EVIDENCE_TECH_TRANSFERRING]: "Evid Tech Transfer",
  [EVIDENCE_TECH_LAB_EXAM_ASSIST]: "Evid Tech Lab Assist",
  [OC_EVIDENCE_TRANSPORT_SHIPPING]: "Evid Transport &/or ship",
  [DESK_REVIEW_OC]: "Desk review",
  [FOLLOW_UP_CASE_WORK]: "Follow up case wrk",
  [INV_REPORT_WITH_CAPTIONED_PHOTOS]: "Inv Report w photos",
  [EE_REPORT]: "EE Report",
  [CASE_REVIEW_FOR_DEPO_PREP]: "Depo Prep",
  [TESTIMONY_TIME]: "Testimony",
  [TECH_REVIEW_NFPA_921]: "Tech Review",
  [SENIOR_EE_REPORT]: "Senior EE Report",
  [ADDITIONAL_ADMIN_WORK]: "Admin",
  [TRAINING_TIME]: "Training",
  [EE_TECH_REVIEW_NFPA_921]: "EE Tech Review",
};

export const BILLING_OPTION_SORT_ORDER: Record<string, number> = {
  [OC_ON_SCENE_EXAM]: 1,
  [OC_CONTINUED_WITH_JSE]: 2,
  [OC_CONTINUED_WITH_LAB_EXAM]: 3,
  [FOLLOW_UP_CASE_WORK]: 4,
  [OC_EVIDENCE_TRANSPORT_SHIPPING]: 5,
  [INV_REPORT_WITH_CAPTIONED_PHOTOS]: 6,
  [CASE_REVIEW_FOR_DEPO_PREP]: 7,
  [TESTIMONY_TIME]: 8,
  [TECH_REVIEW_NFPA_921]: 9,
  [DESK_REVIEW_OC]: 10,
  [EXAM_WITH_HAZMAT]: 11,
  [EE_EXPERT_ANALYSIS]: 13,
  [SENIOR_EE_EXPERT_ANALYSIS]: 14,
  [FIRE_PROTECTION_ENGINEER_EXAM]: 15,
  [MASTER_ELECTRICIAN_EXPERT_ANALYSIS]: 16,
  [AUTO_EQUIPMENT_EXPERT_ANALYSIS]: 17,
  [HVAC_EXPERT_ANALYSIS]: 18,
  [EE_REPORT]: 19,
  [SENIOR_EE_REPORT]: 20,
  [EE_TECH_REVIEW_NFPA_921]: 21,
  [EVIDENCE_TECH_REMOVAL_RETRIEVAL]: 22,
  [EVIDENCE_TECH_TRANSFERRING]: 23,
  [EVIDENCE_TECH_LAB_EXAM_ASSIST]: 24,
  [TRAINING_TIME]: 999,
  [ADDITIONAL_ADMIN_WORK]: 998,
};

export const sortBillingOptions = (options: string[]): string[] => {
  return [...options].sort((left, right) => {
    const leftOrder = BILLING_OPTION_SORT_ORDER[left] ?? Number.MAX_SAFE_INTEGER;
    const rightOrder = BILLING_OPTION_SORT_ORDER[right] ?? Number.MAX_SAFE_INTEGER;

    if (leftOrder !== rightOrder) {
      return leftOrder - rightOrder;
    }

    return left.localeCompare(right);
  });
};

export const ALL_BILLING_OPTIONS = sortBillingOptions([
  OC_ON_SCENE_EXAM,
  OC_CONTINUED_WITH_JSE,
  OC_CONTINUED_WITH_LAB_EXAM,
  FOLLOW_UP_CASE_WORK,
  OC_EVIDENCE_TRANSPORT_SHIPPING,
  INV_REPORT_WITH_CAPTIONED_PHOTOS,
  CASE_REVIEW_FOR_DEPO_PREP,
  TESTIMONY_TIME,
  TECH_REVIEW_NFPA_921,
  DESK_REVIEW_OC,
  EXAM_WITH_HAZMAT,
  EE_EXPERT_ANALYSIS,
  SENIOR_EE_EXPERT_ANALYSIS,
  FIRE_PROTECTION_ENGINEER_EXAM,
  MASTER_ELECTRICIAN_EXPERT_ANALYSIS,
  AUTO_EQUIPMENT_EXPERT_ANALYSIS,
  HVAC_EXPERT_ANALYSIS,
  EE_REPORT,
  SENIOR_EE_REPORT,
  EVIDENCE_TECH_REMOVAL_RETRIEVAL,
  EVIDENCE_TECH_TRANSFERRING,
  EVIDENCE_TECH_LAB_EXAM_ASSIST,
  TRAINING_TIME,
  ADDITIONAL_ADMIN_WORK,
  EE_TECH_REVIEW_NFPA_921,
]);

export const BILLING_OPTIONS_MAP: Record<string, string[]> = {
  [IApiInvestigationRoleNames.Investigator]: sortBillingOptions([
    OC_ON_SCENE_EXAM,
    OC_CONTINUED_WITH_JSE,
    OC_CONTINUED_WITH_LAB_EXAM,
    FOLLOW_UP_CASE_WORK,
    OC_EVIDENCE_TRANSPORT_SHIPPING,
    INV_REPORT_WITH_CAPTIONED_PHOTOS,
    CASE_REVIEW_FOR_DEPO_PREP,
    TESTIMONY_TIME,
    DESK_REVIEW_OC,
    EXAM_WITH_HAZMAT,
    TRAINING_TIME,
  ]),
  [IApiInvestigationRoleNames.FormerInvestigator]: sortBillingOptions([
    OC_ON_SCENE_EXAM,
    OC_CONTINUED_WITH_JSE,
    OC_CONTINUED_WITH_LAB_EXAM,
    FOLLOW_UP_CASE_WORK,
    OC_EVIDENCE_TRANSPORT_SHIPPING,
    INV_REPORT_WITH_CAPTIONED_PHOTOS,
    CASE_REVIEW_FOR_DEPO_PREP,
    TESTIMONY_TIME,
    DESK_REVIEW_OC,
    EXAM_WITH_HAZMAT,
    TRAINING_TIME,
  ]),
  [IApiInvestigationRoleNames.TechReviewer]: sortBillingOptions([TECH_REVIEW_NFPA_921, TRAINING_TIME]),
  [IApiInvestigationRoleNames.EngineerTechReviewer]: sortBillingOptions([TECH_REVIEW_NFPA_921, TRAINING_TIME]),
  [IApiInvestigationRoleNames.AutoExpert]: sortBillingOptions([AUTO_EQUIPMENT_EXPERT_ANALYSIS, TRAINING_TIME]),
  [IApiInvestigationRoleNames.HvacExpert]: sortBillingOptions([HVAC_EXPERT_ANALYSIS, TRAINING_TIME]),
  [IApiInvestigationRoleNames.ElectricalEngineer]: sortBillingOptions([
    EXAM_WITH_HAZMAT,
    EE_EXPERT_ANALYSIS,
    FOLLOW_UP_CASE_WORK,
    OC_EVIDENCE_TRANSPORT_SHIPPING,
    DESK_REVIEW_OC,
    EE_REPORT,
    CASE_REVIEW_FOR_DEPO_PREP,
    TESTIMONY_TIME,
    TRAINING_TIME,
  ]),
  [IApiInvestigationRoleNames.SrElectricalEngineer]: sortBillingOptions([
    EXAM_WITH_HAZMAT,
    SENIOR_EE_EXPERT_ANALYSIS,
    FOLLOW_UP_CASE_WORK,
    OC_EVIDENCE_TRANSPORT_SHIPPING,
    DESK_REVIEW_OC,
    CASE_REVIEW_FOR_DEPO_PREP,
    TESTIMONY_TIME,
    SENIOR_EE_REPORT,
    TRAINING_TIME,
    EE_TECH_REVIEW_NFPA_921
  ]),
  [IApiInvestigationRoleNames.MasterElectrician]: sortBillingOptions([
    MASTER_ELECTRICIAN_EXPERT_ANALYSIS,
    TRAINING_TIME,
    FOLLOW_UP_CASE_WORK,
    INV_REPORT_WITH_CAPTIONED_PHOTOS,
    CASE_REVIEW_FOR_DEPO_PREP,
    TESTIMONY_TIME,
  ]),
  [IApiInvestigationRoleNames.FireProtectionEngineer]: sortBillingOptions([
    FIRE_PROTECTION_ENGINEER_EXAM,
    DESK_REVIEW_OC,
    FOLLOW_UP_CASE_WORK,
    TRAINING_TIME,
    TESTIMONY_TIME
  ]),
  [IApiInvestigationRoleNames.EvidenceTechnician]: sortBillingOptions([
    EVIDENCE_TECH_REMOVAL_RETRIEVAL,
    EVIDENCE_TECH_TRANSFERRING,
    EVIDENCE_TECH_LAB_EXAM_ASSIST,
    TRAINING_TIME,
  ]),
  [IApiInvestigationRoleNames.RegionalManager]: ALL_BILLING_OPTIONS,
  [IApiInvestigationRoleNames.AdministrativeStaff]: ALL_BILLING_OPTIONS,
  [IApiInvestigationRoleNames.Billing]: ALL_BILLING_OPTIONS,
  [IApiInvestigationRoleNames.Editor]: ALL_BILLING_OPTIONS,
  [IApiInvestigationRoleNames.Intake]: ALL_BILLING_OPTIONS,
  ['Unlinked']: sortBillingOptions([
    TRAINING_TIME,
    ADDITIONAL_ADMIN_WORK,
  ])
};

export const TRAINING_HOURS_TYPE_NAME = 'Training Hours';
export const ADMINISTRATIVE_HOURS_TYPE_NAME = 'Administrative Hours';
